<template>
  <div class="content-wrapper" v-if="task">
    <div class="header-container">
      <h1>Update Task</h1>
      <div class="status">
        <span>{{ this.$store.getters.statusNamebyID(task.status) }}</span>
        <StatusCircle :task="task"></StatusCircle>
      </div>
    </div>
    <Task :task="task"></Task>

    <div class="button-container">
      <button v-if="user.data.firestore.isAdmin" :disabled="disableButtons" class="button button--thin button--ghost button--margin-right-auto" data-cy="delete-button" @click="openDeleteModal = true">
        Delete
      </button>
      <div class="download" v-if="user.data.firestore.isAdmin && task.type == 'linkbuilding'">
        <a :href="'https://europe-west3-freelance-ffddb.cloudfunctions.net/generate-word-doc-v2?id=' + $route.params.id" target="_blank">Download Word Doc</a>
      </div>
      <button v-if="displaySaveButton" :disabled="disableButtons" class="button button--thin button--margin-left" @click="updateTask(task.status, task.status, 'save')">Save</button>
      <button v-if="!user.data.firestore.isAdmin" :disabled="disableButtons" class="button button--thin button--margin-left" @click="unclaimTaskById('unclaim this task')">
        Unclaim
      </button>
      <button
        :disabled="disableButtons"
        v-if="displaySubmitButton && !user.data.firestore.isAdmin"
        class="button button--thin button--margin-left"
        data-cy="review-button"
        @click="updateTask(task.status, 'pending-review', 'submit this task')"
      >
        Submit task
      </button>

      <template v-if="user.data.firestore.isAdmin">
        <button
          :disabled="disableButtons"
          v-if="task.status == 'revision-needed'"
          class="button button--thin button--margin-left"
          data-cy="review-button"
          @click="updateTask(task.status, 'pending-review', 'change back to pending review')"
        >
          Pending review
        </button>
        <button :disabled="disableButtons" v-if="task.status == 'pending-review'" class="button button--thin button--margin-left button--danger" data-cy="revision-button" @click="modalOpen = true">
          Needs revision
        </button>
        <button
          :disabled="disableButtons"
          v-if="task.status == 'pending-review'"
          class="button button--thin button--margin-left"
          data-cy="approve-button"
          @click="updateTask(task.status, 'approved', 'approve this task')"
        >
          Approve
        </button>
        <button :disabled="disableButtons" v-if="task.status == 'approved'" class="button button--thin button--margin-left button--danger" data-cy="revision-button" @click="modalOpen = true">
          Needs revision
        </button>
        <button :disabled="disableButtons" v-if="task.status == 'approved'" class="button button--thin button--margin-left" @click="updateTask(task.status, 'exported', 'mark this task as exported')">
          Mark as exported
        </button>
        <button
          :disabled="disableButtons"
          v-if="task.status == 'exported'"
          class="button button--thin button--margin-left button--danger"
          @click="updateTask(task.status, 'approved', 'change back to approved')"
        >
          Change back to Approved
        </button>
      </template>
      <RevisionEmail v-if="modalOpen" :email="emailData" :submittedBy="task.claimedBy" :type="'task'" :taskStatus="task.status" v-on:update:modalOpen="modalOpen = $event"></RevisionEmail>
      <ConfirmDeletion
        v-if="openDeleteModal"
        :objectName="'task'"
        :objectId="task.id"
        :eventName="'openDeleteModal'"
        v-on:deleted="deleteItem"
        v-on:update:openDeleteModal="openDeleteModal = $event"
      ></ConfirmDeletion>
    </div>
  </div>
</template>

<script>
import Task from '@/components/task'
import RevisionEmail from '@/components/revisionemail'
import StatusCircle from '@/components/circle'
import ConfirmDeletion from '@/components/confirm-deletion'

import { mapActions, mapGetters } from 'vuex'
import emailApi from '@/services/email'

export default {
  name: 'taskId',
  data() {
    return {
      disableButtons: false,
      modalOpen: false,
      openDeleteModal: false,
      emailData: {
        subject: 'Your task needs revision',
        recipients: [],
        body: '',
      },
    }
  },
  methods: {
    ...mapActions(['fetchTaskById', 'saveTask', 'deleteTask', 'unclaimTask']),
    onClose(newData) {
      this.modalOpen = newData
    },
    async unclaimTaskById(message) {
      await this.$dialog.confirm('Are you sure you want to ' + message + '?')
      this.disableButtons = true

      try {
        await this.unclaimTask({ task: this.task })

        this.$notify({
          text: 'Success',
          type: 'success',
        })

        this.$router.go(-1)
      } catch (error) {
        this.$notify({
          text: 'Error',
          type: 'error',
        })
      }

      this.disableButtons = false
    },
    async updateTask(currentStatus, newStatus, message) {
      await this.$dialog.confirm('Are you sure you want to ' + message + '?')

      this.disableButtons = true
      this.task.status = newStatus

      try {
        await this.saveTask({ task: this.task })

        if (status == 'revision-needed' && this.emailData.body != '') {
          await emailApi.sendEmail(this.emailData)
        }

        this.$notify({
          text: 'Success',
          type: 'success',
        })
      } catch (error) {
        this.task.status = currentStatus

        this.$notify({
          text: 'Error',
          type: 'error',
        })
      }

      this.disableButtons = false
    },
    deleteItem(res) {
      if (!res) return
      this.deleteTask(this.task.id)

      this.$notify({
        text: 'The task was successfully deleted',
        type: 'success',
      })
      this.$router.back(0)
    },
  },
  mounted: function() {
    this.fetchTaskById({ taskId: this.$route.params.id })
  },
  computed: {
    ...mapGetters(['task', 'user']),
    displaySaveButton() {
      return this.user.data.firestore.isAdmin || this.task.status === 'claimed' || this.task.status === 'revision-needed'
    },
    displaySubmitButton() {
      return this.task.status == 'claimed' || this.task.status == 'revision-needed'
    },
  },
  watch: {
    '$route.params': {
      async handler(newValue) {
        const taskId = newValue.id
        await this.fetchTaskById({ taskId })
      },
      immediate: true,
    },
  },
  components: {
    Task,
    StatusCircle,
    RevisionEmail,
    ConfirmDeletion,
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/shared-styles/button.scss';

.header-container,
.status {
  display: flex;
  align-items: center;
}
.status {
  margin-left: auto;
  font-size: 0.8125rem;
  > span {
    margin-right: 0.5rem;
  }
}
.button-container {
  display: flex;
}
.download {
  display: flex;
  align-items: center;
  > a {
    color: var(--color-cta);
    text-decoration: none;
    font-size: 0.875rem;
    &:hover {
      color: var(--color-cta-hover);
    }
  }
}
</style>
